function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import ParticipantGroup from './participant_group';
import Collection from './collection';
import _ from 'underscore'; // @namespace Model

var ParticipantGroups = /*#__PURE__*/function (_Collection) {
  _inheritsLoose(ParticipantGroups, _Collection);

  function ParticipantGroups() {
    return _Collection.apply(this, arguments) || this;
  }

  var _proto = ParticipantGroups.prototype;

  _proto.url = function url() {
    return '/api/participant_groups';
  }
  /*
   * return a boolean of whether a collection
   * of participant groups matched any on this
   * collection that are checked
   */
  ;

  _proto.anyMatchChecked = function anyMatchChecked(groups) {
    var participantIds = groups.pluck('id'); // Add ungrouped if the participant isn't in any groups

    if (!participantIds.length) {
      participantIds.push(0);
    }

    return _.intersection(this.checkedIds(), participantIds).length > 0; // force boolean
  };

  _proto.onlyUngrouped = function onlyUngrouped() {
    return this.all(function (group) {
      return group.isUngrouped();
    });
  };

  _proto.lastId = function lastId() {
    var maxItem = this.max(function (item) {
      return item.id;
    });
    return (maxItem != null ? maxItem.id : undefined) || 1;
  };

  _proto.checked = function checked() {
    return this.where({
      checked: true
    });
  };

  _proto.allChecked = function allChecked() {
    return this.checked().length === this.length;
  };

  _proto.checkedIds = function checkedIds() {
    return _.pluck(this.checked(), 'id');
  };

  _proto.anyChecked = function anyChecked() {
    return this.checked().length > 0;
  }
  /*
   * find the next group in
   * the collection if it exists
   */
  ;

  _proto.next = function next(group) {
    var currentIndex = this.indexOf(group);
    return this.at(currentIndex + 1);
  }
  /*
   * find the previous group in
   * the collection if it exists
   */
  ;

  _proto.previous = function previous(group) {
    var currentIndex = this.indexOf(group);

    if (currentIndex === 0) {
      return;
    }

    return this.at(currentIndex - 1);
  };

  _createClass(ParticipantGroups, [{
    key: "model",
    get: function get() {
      return ParticipantGroup;
    }
  }]);

  return ParticipantGroups;
}(Collection);

export { ParticipantGroups as default };